import { useEffect } from 'react'
import { listProductionItems, listProdItemCategories } from './storage'

export default function useInitial() {
    useEffect(() => {
        Promise.all([listProductionItems.load(), listProdItemCategories.load()])
    }, [])
}
